<template>
  <div>
      <v-img v-if="hasImage" :src="imageUrl" :width="width" :height="height" :style="style"/>
    <slot/>
  </div>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "atom",
    name: "Userlogo",
    props: {
      "src": String,
      "icon": Boolean
    },
    computed: {
      hasImage () {
        return !!this.src;
      },
      imageUrl () {
        return this.src ? this.src : "";
      },
      width () {
        if (this.icon) {
          return "40px"
        }
        return "100%"
      },
      height () {
        if (this.icon) {
          return "40px";
        }
        return undefined;
      },
      style () {
        if (this.icon) {
          return {
            "border-radius": "50%"
          }
        }
        return {}
      }
    }
  }
</script>

<style scoped>

</style>
